import Modal from './Modal';
import ModalUtils from './ModalUtils';
import IConformationModalConfig from './IConfirmationModalConfig';

class ConfirmationModal extends Modal {
  $btnConfirm: JQuery<HTMLElement>;

  $btnCancel: JQuery<HTMLElement>;

  closeOnConfirm: boolean;

  onConfirm: () => void;

  onCancel: () => void;

  constructor(config_: Partial<IConformationModalConfig>) {
    const config = {
      ...Modal.defaults,
      ...{
        labelBtnConfirm: 'Confirm',
        labelBtnCancel: 'Cancel',
        onConfirm: () => {},
        onCancel: () => {},
        closeOnConfirm: true,
      },
      ...config_,
    };

    const $btnConfirm = ModalUtils.makePrimaryButton(config.labelBtnConfirm);
    const $btnCancel = ModalUtils.makeSecondaryButton(config.labelBtnCancel);

    config.footerContents = [
      $btnConfirm[0],
      $btnCancel[0],
    ];

    super(config);

    this.onConfirm = config.onConfirm;
    this.onCancel = config.onCancel;
    this.closeOnConfirm = config.closeOnConfirm;

    $btnConfirm.on('click', this.onBtnConfirm);
    $btnCancel.on('click', this.onBtnCancel);

    this.$btnConfirm = $btnConfirm;
    this.$btnCancel = $btnCancel;
  }

  onBtnConfirm = () => {
    const { onConfirm, closeOnConfirm } = this;

    if (onConfirm) {
      onConfirm();
    }

    if (closeOnConfirm) {
      this.close();
    }
  };

  onBtnCancel = () => {
    this.dismiss();
  };

  dismiss() {
    this.onCancel?.();

    super.dismiss();
  }

  close() {
    this.$btnConfirm.off();
    this.$btnCancel.off();

    super.close();
  }
}

export default ConfirmationModal;
